/**
 * Uncommon Grounds Shopify Theme
 * Main JavaScript File
 */

(function() {
  'use strict';

  // ========================================
  // Cart Functionality
  // ========================================
  
  function updateCartCount() {
  fetch('/cart.js', { credentials: 'same-origin' })
    .then(r => r.json())
    .then(cart => {
      const el = document.getElementById('cart-count');
      if (!el) return;

      el.textContent = String(cart.item_count);
      el.style.display = cart.item_count > 0 ? 'inline-flex' : 'none';
    })
    .catch(err => console.error('Error updating cart count:', err));
}


  // ========================================
  // Product Image Gallery
  // ========================================
  
  function initProductGallery() {
    const thumbnails = document.querySelectorAll('.product-thumbnail');
    const mainImage = document.getElementById('ProductMainImage');
    
    if (!thumbnails.length || !mainImage) return;
    
    thumbnails.forEach(thumbnail => {
      thumbnail.addEventListener('click', function() {
        const imageUrl = this.src.replace('_100x100', '_800x800');
        mainImage.src = imageUrl;
        
        // Remove active class from all thumbnails
        thumbnails.forEach(t => t.classList.remove('active'));
        // Add active class to clicked thumbnail
        this.classList.add('active');
      });
    });
  }

  // ========================================
  // Collection Sorting
  // ========================================
  
  function initCollectionSorting() {
    const sortSelect = document.getElementById('SortBy');
    
    if (!sortSelect) return;
    
    sortSelect.addEventListener('change', function() {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
    
    // Set current sort value from URL
    const urlParams = new URLSearchParams(window.location.search);
    const currentSort = urlParams.get('sort_by');
    if (currentSort) {
      sortSelect.value = currentSort;
    }
  }

  // ========================================
  // Add to Cart Form Handler
  // ========================================
  
  function initAddToCart() {
  document.addEventListener('submit', function (e) {
    const form = e.target;
    if (!(form instanceof HTMLFormElement)) return;

    // Match Shopify add-to-cart forms
    if (!form.matches('form[action*="/cart/add"]')) return;

    e.preventDefault();

    const formData = new FormData(form);
    const button = form.querySelector('button[type="submit"], button[name="add"]');
    const originalText = button ? button.textContent : '';

    if (button) {
      button.textContent = 'Adding...';
      button.disabled = true;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      credentials: 'same-origin'
    })
      .then(async (response) => {
        const data = await response.json();
        if (!response.ok) throw new Error(data?.description || 'Add to cart failed');
        return data;
      })
      .then(() => {
        updateCartCount();
        if (button) button.textContent = 'Added!';

        setTimeout(() => {
          if (button) {
            button.textContent = originalText;
            button.disabled = false;
          }
        }, 1200);
      })
      .catch((error) => {
        console.error('Error adding to cart:', error);
        if (button) {
          button.textContent = 'Error - Try Again';
          setTimeout(() => {
            button.textContent = originalText;
            button.disabled = false;
          }, 1500);
        }
      });
  }, true);
}


  // ========================================
  // Quantity Input Handlers
  // ========================================
  
  function initQuantityInputs() {
    const quantityInputs = document.querySelectorAll('.quantity-input');
    
    quantityInputs.forEach(input => {
      input.addEventListener('change', function() {
        if (this.value < 1) {
          this.value = 1;
        }
      });
    });
  }

  // ========================================
  // Newsletter Form Handler
  // ========================================
  
  function initNewsletterForm() {
    const forms = document.querySelectorAll('.newsletter-form');
    
    forms.forEach(form => {
      form.addEventListener('submit', function(e) {
        const emailInput = form.querySelector('input[type="email"]');
        
        if (!emailInput.value || !emailInput.validity.valid) {
          e.preventDefault();
          alert('Please enter a valid email address.');
        }
      });
    });
  }

  // ========================================
  // Smooth Scroll for Anchor Links
  // ========================================
  
  function initSmoothScroll() {
    const links = document.querySelectorAll('a[href^="#"]');
    
    links.forEach(link => {
      link.addEventListener('click', function(e) {
        const href = this.getAttribute('href');
        
        if (href === '#') return;
        
        const target = document.querySelector(href);
        
        if (target) {
          e.preventDefault();
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      });
    });
  }

  // ========================================
  // Accessibility: Skip to Content
  // ========================================
  
  function initAccessibility() {
    const skipLink = document.querySelector('.skip-to-content-link');
    
    if (skipLink) {
      skipLink.addEventListener('click', function(e) {
        e.preventDefault();
        const target = document.querySelector(this.getAttribute('href'));
        if (target) {
          target.focus();
          target.scrollIntoView({ behavior: 'smooth' });
        }
      });
    }
  }

  // ========================================
  // Initialize All Functions on DOM Ready
  // ========================================
  
  function init() {
    updateCartCount();
    initProductGallery();
    initCollectionSorting();
    initAddToCart();
    initQuantityInputs();
    initNewsletterForm();
    initSmoothScroll();
    initAccessibility();
  }

  // Run initialization when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // ========================================
  // Expose public API
  // ========================================
  
  window.UncommonGrounds = {
    updateCartCount: updateCartCount
  };

})();
